module.exports = __webpack_public_path__ + "img/service-card-3.aa88cf4b.png";